import { render, staticRenderFns } from "./BtnRemanejamentoValores.vue?vue&type=template&id=2da0d199&"
import script from "./BtnRemanejamentoValores.vue?vue&type=script&lang=js&"
export * from "./BtnRemanejamentoValores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports